<template>
  <div class="invisible-scrollbar">
    <v-card style="display: contents">
      <div class="mx-3">
        <div class="pt-8 text-h6 font-weight-bold page-title">
          {{ $t("message.UserManagement") }}
        </div>
        <v-card-text>
          <v-card elevation="10" class="pa-4 my-4 rounded-lg">
            <v-row>
              <v-col cols="12" md="5">
                <v-text-field
                  :label="$t('message.Search')"
                  append-icon="mdi-database-search-outline"
                  v-model="search"
                  @keyup.enter="SearchDataUser(search)"
                  clearable
                  outlined
                  dense
                ></v-text-field>
              </v-col>

              <!-- <v-col cols="12" md="4" class="text-md-left text-center">
                <v-btn
                  height="40"
                  color="green"
                  class="white--text px-8"
                  @click="CreateNewUser()"
                >
                  Create
                </v-btn>
              </v-col> -->
            </v-row>
          </v-card>

          <v-card elevation="10" class="pa-4 my-4 rounded-lg">
            <v-data-table
              :headers="$vuetify.breakpoint.smAndDown ? headersMobile : headers"
              :items="ListData"
              hide-default-footer
              class="data-table"
              :items-per-page="itemsPerPage"
              :page.sync="page"
              single-line
              hide-details
            >
              <template
                v-if="!$vuetify.breakpoint.smAndDown"
                v-slot:item="{ item, index }"
              >
                <tr>
                  <td class="cell">{{ no_run + (index + 1) }}</td>
                  <td class="cell">{{ item.username }}</td>
                  <td class="cell">
                    {{ item.firstname + " " + item.lastname }}
                  </td>
                  <td class="cell">{{ item.email }}</td>
                  <td class="cell">{{ item.roleName }}</td>

                  <!-- <td class="text-center">
                    <v-icon :color="item.qr ? 'green' : 'red'">
                      {{ item.qr ? "mdi-check-circle" : "mdi-close-circle" }}
                    </v-icon>
                  </td>

                  <td class="text-center">
                    <v-icon :color="item.callLift ? 'green' : 'red'">
                      {{
                        item.callLift ? "mdi-check-circle" : "mdi-close-circle"
                      }}
                    </v-icon>
                  </td> -->

                  <td class="text-center">
                    <v-icon :color="item.preRegister ? 'green' : 'red'">
                      {{
                        item.preRegister
                          ? "mdi-check-circle"
                          : "mdi-close-circle"
                      }}
                    </v-icon>
                  </td>

                  <td class="text-center">
                    <v-icon :color="item.redemption ? 'green' : 'red'">
                      {{
                        item.redemption
                          ? "mdi-check-circle"
                          : "mdi-close-circle"
                      }}
                    </v-icon>
                  </td>

                  <td class="text-center">
                    <v-icon :color="item.manageUser ? 'green' : 'red'">
                      {{
                        item.manageUser
                          ? "mdi-check-circle"
                          : "mdi-close-circle"
                      }}
                    </v-icon>
                  </td>
                  <td class="py-2 text-center">
                    <v-btn
                      :color="GetColor(item.active)"
                      rounded
                      class="text-capitalize"
                      depressed
                      style="width: 100px"
                    >
                      <span :style="{ color: GetColorText(item.active) }">
                        {{ item.active ? "Active" : "Inactive" }}
                      </span>
                    </v-btn>
                  </td>
                  <td class="text-center">
                    <v-btn
                      class="mx-1"
                      fab
                      small
                      dark
                      color="orange"
                      @click="OpenUserDetailDialog(item.userID, item.statusUse)"
                    >
                      <v-icon>mdi-pencil-outline</v-icon>
                    </v-btn>

                    <v-btn
                      class="mx-1"
                      fab
                      small
                      dark
                      :color="item.active ? 'red' : 'green'"
                      @click="
                        OpenChangeActiveUserDialog(
                          item.userName,
                          item.userID,
                          item.active
                        )
                      "
                    >
                      <v-icon>
                        {{
                          item.active ? "mdi-trash-can-outline" : "mdi-restore"
                        }}
                      </v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
            <v-row class="mt-4" align="center" justify="space-between">
              <v-col cols="12" md="3"></v-col>

              <v-col cols="12" md="4" class="text-center">
                <v-pagination
                  v-model="page"
                  :length="pageCount"
                  @input="ChangePage(page)"
                ></v-pagination>
              </v-col>

              <v-col cols="12" md="2">
                <v-autocomplete
                  dense
                  solo
                  v-model="itemsPerPage"
                  @input="ChangePerPage(itemsPerPage)"
                  :items="items"
                  label="Items/page"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-card>
        </v-card-text>
      </div>
    </v-card>

    <v-dialog v-model="LoadingDialog" persistent width="auto">
      <v-card
        class="pa-6 d-flex flex-column align-center justify-center"
        elevation="8"
        rounded="xl"
      >
        <v-progress-circular
          indeterminate
          color="indigo"
          size="70"
          width="6"
        ></v-progress-circular>
        <span class="mt-4 text-subtitle-1 font-weight-medium"
          >Loading, please wait...</span
        >
      </v-card>
    </v-dialog>

    <v-dialog v-model="UserDetailDialog" persistent max-width="820px">
      <v-card class="rounded-xl">
        <v-card-title
          class="py-3 px-6 d-flex align-center"
          style="background: #1d2939; color: white"
        >
          <span class="text-h6 font-weight-bold">
            {{ $t("message.ManageUser") }}
          </span>
          <v-spacer></v-spacer>
          <v-btn icon @click="UserDetailDialog = false">
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="px-8 pt-6 pb-10">
          <div class="section-header">
            <span>{{ $t("message.SyncMemberFineday") }}</span>
          </div>
          <v-row class="mt-2">
            <v-col cols="12" md="8">
              <v-autocomplete
                :items="MemberList"
                item-text="memberName"
                item-value="memberID"
                outlined
                dense
                clearable
                :label="$t('message.Search')"
                v-model="SearchMemberID"
                @change="getMasMemberByMemberID(SearchMemberID)"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <div class="section-header mt-3">
            <span>User Information</span>
          </div>

          <v-row class="mt-2">
            <v-col cols="12" md="6">
              <v-text-field
                :label="$t('message.Username')"
                dense
                outlined
                :disabled="EditStatus"
                v-model="Username"
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                dense
                outlined
                :label="$t('message.Password')"
                placeholder="Enter password"
                :append-icon="ShowPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="ShowPassword ? 'text' : 'password'"
                @click:append="ShowPassword = !ShowPassword"
                v-model="Password"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                :label="$t('message.MemberID')"
                dense
                outlined
                disabled
                v-model="MemberID"
              />
            </v-col>

            <v-col cols="12" md="8">
              <v-text-field
                :label="$t('message.Tenant')"
                dense
                outlined
                disabled
                v-model="Tenant"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                :label="$t('message.FirstName')"
                dense
                outlined
                v-model="FirstName"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                :label="$t('message.LastName')"
                dense
                outlined
                v-model="LastName"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field :label="$t('message.Email')" dense outlined v-model="Email" />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                :label="$t('message.Telephone')"
                dense
                outlined
                v-model="Telephone"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-select
                :items="RoleListData"
                item-text="roleName"
                item-value="roleId"
                dense
                outlined
                :label="$t('message.RoleName')"
                v-model="RoleId"
              ></v-select>
            </v-col>

            <v-col cols="12" md="6">
              <v-radio-group row v-model="ActiveStatus" class="mt-1">
                <v-radio :label="$t('message.Active')" value="1"></v-radio>
                <v-radio :label="$t('message.InActive')" value="2"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>

          <template v-if="RedemptionStatus">
            <v-divider class="my-6"></v-divider>

            <div class="section-header">
              <v-icon class="mr-2" size="22">mdi-gift-outline</v-icon>
              <span>{{ $t('message.RedemptionSettings') }}</span>
            </div>

            <v-row class="mt-3">
              <v-col cols="12" md="6">
                <v-select
                  :items="DepartmentList"
                  item-text="departmentName"
                  item-value="departmentId"
                  dense
                  outlined
                  :label="$t('message.Department')"
                  v-model="Department"
                />
              </v-col>

              <v-col cols="12" md="6">
                <v-select
                  :items="RedemptionTypeList"
                  item-text="redempType_Name"
                  item-value="redempType_Id"
                  dense
                  outlined
                  :label="$t('message.RedemptionType')"
                  v-model="RedemptionType"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="6">
                <v-select
                  :items="UserLevelList"
                  item-text="userLevel_Name"
                  item-value="userLevel_Id"
                  dense
                  outlined
                  :label="$t('message.UserLevel')"
                  v-model="UserLevel"
                />
              </v-col>
            </v-row>
          </template>
          <v-row class="mt-8" justify="center">
            <v-col cols="12" md="3">
              <v-btn
                block
                x-large
                color="#1D9D58"
                class="white--text rounded-lg"
                @click="UpdateDataUser()"
              >
                {{ $t('message.Submit') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="ChangeActiveUserDialog" persistent width="500">
      <v-card>
        <v-card-title>
          <template v-if="Active_Register">
            <h4>คุณต้องการ Inactive Username นี้ ใช่หรือไม่ ?</h4>
          </template>
          <template v-else>
            <h4>คุณต้องการ Active Username นี้ ใช่หรือไม่ ?</h4>
          </template>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="6"></v-col>
            <v-col cols="12" md="6"></v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-btn
                block
                color="#5cb85c"
                style="color: white"
                @click="ChangeActiveUsername()"
                class="rounded-lg"
                x-large
                >YES</v-btn
              >
            </v-col>
            <v-col cols="12" md="6">
              <v-btn
                block
                color="#d9534f"
                style="color: white"
                @click="CloseChangeActiveUserDialog()"
                class="rounded-lg"
                x-large
                >NO</v-btn
              >
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import enurl from "@/api/environment";
import Swal from "sweetalert2/dist/sweetalert2.js";

export default {
  name: "ManageUser",
  components: {},
  data() {
    return {
      url: enurl.apiUrl,

      LoadingDialog: false,
      UserDetailDialog: false,
      ChangeActiveUserDialog: false,

      items: [10, 15, 20, 50, 100],
      pageCount: 0, //จำนวนหน้าทั้งหมด
      page: 1, //อยู่หน้าที่เท่าไร
      itemsPerPage: 10, //จำนวนรายการต่อหน้า
      search: "",
      no_run: 0,

      UserName_Register: "",
      UserId_Register: 0,
      Active_Register: false,

      RoleName_User: "",
      StatusUse_User: false,

      ListData: [],
      RoleListData: [],
      RoleId: 0,
      UserID: null,
      MemberList: [],
      RedemptionTypeList: [],
      DepartmentList: [],
      UserLevelList: [],

      SearchMemberID: null,
      FirstName: "",
      LastName: "",
      Username: "",
      Password: "",
      MemberID: "",
      CardID: "",
      TenantID: "",
      Tenant: "",
      Email: "",
      Telephone: "",
      ShowPassword: false,
      RedemptionType: null,
      UserLevel: null,
      ActiveStatus: null,
      Department: null,
      RedemptionStatus: false,

      EditStatus: false,
    };
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("message.No"),
          sortable: false,
          align: "left",
        },
        {
          text: this.$t("message.Username"),
          align: "left",
          sortable: false,
        },
        {
          text: this.$t("message.FullName"),
          align: "left",
          sortable: false,
        },
        {
          text: this.$t("message.Email"),
          align: "left",
          sortable: false,
        },
        {
          text: this.$t("message.RoleName"),
          align: "left",
          sortable: false,
        },
        // {
        //   text: "MyQR",
        //   align: "center",
        //   sortable: false,
        // },
        // {
        //   text: "CallLift",
        //   align: "center",
        //   sortable: false,
        // },
        {
          text: this.$t("message.PreRegister"),
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("message.Redemption"),
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("message.ManageUser"),
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("message.Status"),
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("message.Action"),
          align: "center",
          sortable: false,
        },
      ];
    },
    headersMobile() {
      return [
        {
          text: "No",
          sortable: false,
          align: "left",
        },
        {
          text: "Username",
          align: "left",
          sortable: false,
        },
        {
          text: "FullName",
          align: "left",
          sortable: false,
        },
        {
          text: "Email",
          align: "left",
          sortable: false,
        },
        {
          text: "Role Name",
          align: "left",
          sortable: false,
        },
        {
          text: "Action",
          align: "center",
          sortable: false,
        },
      ];
    },
  },

  async mounted() {
    let self = this;
    await self.GetUserList();
    await self.getMasMember();
    await self.getRedemptionDepartment();
    await self.getDepartment();
    await self.getUserStampLevel();
    await self.GetRoleUser();
  },

  methods: {
    CreateNewUser() {
      let self = this;
      self.UserDetailDialog = true;
    },

    TogglePassword() {
      let self = this;
      var x = document.getElementById("password");
      if (x.type === "password") {
        x.type = "text";
        self.ShowPassword = false;
      } else {
        x.type = "password";
        self.ShowPassword = true;
      }
    },

    getMasMember() {
      let self = this;
      self.LoadingDialog = true;
      axios
        .get(`${self.url}User/getMasMember`)
        .then(function (response) {
          if (response.data.status == 0) {
            self.LoadingDialog = false;
            self.MemberList = response.data.data;
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          self.ChangeActiveUserDialog = false;
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 500,
            text: error,
          });
        });
    },

    getRedemptionDepartment() {
      let self = this;
      self.LoadingDialog = true;
      axios
        .get(`${self.url}Management/getRedemptionDepartment`)
        .then(function (response) {
          if (response.data.status == 0) {
            self.LoadingDialog = false;
            self.RedemptionTypeList = response.data.data;
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          self.ChangeActiveUserDialog = false;
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 500,
            text: error,
          });
        });
    },

    getDepartment() {
      let self = this;
      self.LoadingDialog = true;
      axios
        .get(`${self.url}Management/getDepartment`)
        .then(function (response) {
          if (response.data.status == 0) {
            self.LoadingDialog = false;
            self.DepartmentList = response.data.data;
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          self.ChangeActiveUserDialog = false;
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 500,
            text: error,
          });
        });
    },

    getUserStampLevel() {
      let self = this;
      self.LoadingDialog = true;
      axios
        .get(`${self.url}Management/getUserStampLevel`)
        .then(function (response) {
          if (response.data.status == 0) {
            self.LoadingDialog = false;
            self.UserLevelList = response.data.data;
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          self.ChangeActiveUserDialog = false;
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 500,
            text: error,
          });
        });
    },

    getMasMemberByMemberID(member) {
      let self = this;
      if (member != null) {
        self.RedemptionType = null;
        self.UserLevel = null;
        self.Department = null;
        self.RedemptionStatus = null;
        let temp = {
          MemberID: member,
          userID: self.UserID,
        };
        axios
          .post(`${self.url}Management/getMasMemberByMemberID`, temp)
          .then(function (response) {
            if (response.data.status == 0) {
              // console.log(response.data.data);
              self.UserID = response.data.data.userID;
              self.RoleId = response.data.data.roleID;
              self.SearchMemberID = response.data.data.member_Id;
              // self.Username = response.data.data.username;
              // self.Password = response.data.data.password;
              self.MemberID = response.data.data.member_Id;
              // self.CardID = response.data.data.card_id;
              self.TenantID = response.data.data.tenantID;
              self.Tenant = response.data.data.tenant;
              self.FirstName = response.data.data.firstname;
              self.LastName = response.data.data.lastname;
              self.Email = response.data.data.email;
              self.Telephone = response.data.data.telephone;
              self.ActiveStatus =
                response.data.data.active == true
                  ? "1"
                  : response.data.data.active == false
                  ? "2"
                  : null;
              self.RedemptionType = response.data.data.redemptionType;
              self.UserLevel = response.data.data.userStampLevel;
              self.Department = response.data.data.departmentID;
              self.RedemptionStatus = response.data.data.redemption;
            }
          })
          .catch(function (error) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 500,
              text: error,
            });
          });
      }
    },

    ChangePage(value) {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        page: value,
        perPage: self.itemsPerPage,
        search: self.search == null ? "" : self.search,
      };
      axios
        .post(`${self.url}Management/GetUserList`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ListData = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
            self.LoadingDialog = false;
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 500,
            text: error,
          });
        });
    },

    ChangePerPage(value) {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        search: self.search,
        page: 1,
        perPage: value,
      };
      axios
        .post(`${self.url}Management/GetUserList`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ListData = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
            self.LoadingDialog = false;
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 500,
            text: error,
          });
        });
    },

    GetUserList() {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        search: self.search,
        page: self.page,
        perPage: self.itemsPerPage,
      };
      axios
        .post(`${self.url}Management/GetUserList`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ListData = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
            self.LoadingDialog = false;
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 500,
            text: error,
          });
        });
    },

    SearchDataUser(value) {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        search: value,
        page: 1,
        perPage: self.itemsPerPage,
      };
      axios
        .post(`${self.url}Management/GetUserList`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ListData = response.data.data.listData;
            self.pageCount = response.data.data.count;
            // self.pageCount = Math.ceil(
            //   response.data.data.count / self.itemsPerPage
            // );
            self.no_run = (self.page - 1) * self.itemsPerPage;
            self.LoadingDialog = false;
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 500,
            text: error,
          });
        });
    },

    ChangeActiveUsername() {
      let self = this;
      let temp = {
        UserId: self.UserId_Register,
        Active: !self.Active_Register,
      };
      axios
        .post(`${self.url}Management/ChangeActiveUsername`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            Swal.fire({
              icon: "success",
              title: "Success",
              showConfirmButton: false,
              timer: 1500,
            });
            self.ChangeActiveUserDialog = false;
            self.GetUserList();
          }
        })
        .catch(function (error) {
          self.ChangeActiveUserDialog = false;
          // self.LoadingDialog = false;
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 500,
            text: error,
          });
        });
    },

    GetMemberDetailByUserId() {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        UserId: self.UserId_Register,
      };
      axios
        .post(`${self.url}Management/GetMemberDetailByUserId`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.EditStatus = true;
            self.BindingDataUser(response.data.data);
          } else if (response.data.status == 1) {
            Swal.fire({
              icon: "warning",
              title: "warning",
              width: 500,
              text: response.data.message,
            });
            self.EditStatus = true;
            self.BindingDataUser(response.data.data);
          }
        })
        .catch(function (error) {
          self.ChangeActiveUserDialog = false;
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 500,
            text: error,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    BindingDataUser(data) {
      let self = this;
      self.UserID = data.userID;
      self.RoleId = data.roleID;
      self.SearchMemberID = data.member_Id;
      self.Username = data.username;
      self.Password = data.password;
      self.MemberID = data.member_Id;
      self.CardID = data.card_id;
      self.TenantID = data.tenantID;
      self.Tenant = data.tenant;
      self.FirstName = data.firstname;
      self.LastName = data.lastname;
      self.Email = data.email;
      self.Telephone = data.telephone;
      self.ActiveStatus =
        data.active == true ? "1" : data.active == false ? "2" : null;
      self.RedemptionType = data.redemptionType;
      self.UserLevel = data.userStampLevel;
      self.Department = data.departmentID;
      self.RedemptionStatus = data.redemption;
    },

    UpdateDataUser() {
      let self = this;
      let temp = {
        UserId: self.UserId_Register,
        MemberId: self.MemberID,
        roleId: self.RoleId,
        Username: self.Username,
        Password: self.Password,
        FirstName: self.FirstName,
        LastName: self.LastName,
        Telephone: self.Telephone,
        Email: self.Email,
        Tenant: self.TenantID,
        Department: self.Department == "" ? null : self.Department,
        RedemptionType: self.RedemptionType,
        UserStampLevel: self.UserLevel,
        active: self.ActiveStatus == "1" ? true : false,
      };
      self.LoadingDialog = true;
        axios
          .post(`${self.url}Management/UpdateDataUser`, temp)
          .then(function (response) {
            if (response.data.status == 0) {
              Swal.fire({
                icon: "success",
                text: "Success",
                showConfirmButton: false,
                timer: 1500,
              });
              self.UserDetailDialog = false;
              self.GetUserList();
            }
          })
          .catch(function (error) {
            self.ChangeActiveUserDialog = false;
            Swal.fire({
              icon: "error",
              width: 500,
              text: error,
            });
          })
          .finally(() => {
            self.LoadingDialog = false;
          });
      // if (temp.memberId === "") {
      //   Swal.fire({
      //     icon: "error",
      //     width: 500,
      //     text: "กรุณาใส่กรอกข้อมูลให้ครบถ้วน",
      //   });
      // } else {
        
      // }
    },

    GetRoleUser() {
      let self = this;
      axios
        .get(`${self.url}Management/GetRoleName`)
        .then(function (response) {
          if (response.data.status == 0) {
            self.RoleListData = response.data.data;
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 500,
            text: error,
          });
          self.ChangeActiveUserDialog = false;
        });
    },

    OpenUserDetailDialog(userid, statusUse) {
      let self = this;
      self.ClearDataUser();
      self.UserDetailDialog = true;
      self.UserId_Register = userid;
      self.StatusUse_User = statusUse;
      self.GetMemberDetailByUserId();
      // self.GetRoleUser();
    },

    CloseUserDetailDialog() {
      let self = this;
      self.ClearDataUser();
      self.UserDetailDialog = false;
      self.MemberId_MasMember = "";
      self.CardId_MasMember = "";
      self.FullName_MasMember = "";
      self.TenantName_MasMember = "";
    },
    OpenChangeActiveUserDialog(username, userid, active) {
      let self = this;
      self.ChangeActiveUserDialog = true;
      self.UserName_Register = username;
      self.UserId_Register = userid;
      self.Active_Register = active;
    },

    CloseChangeActiveUserDialog() {
      let self = this;
      self.ChangeActiveUserDialog = false;
    },

    ClearDataUser() {
      let self = this;
      self.Username_Register = "";
      self.FirstName = "";
      self.LastName = "";
      self.Username = "";
      self.Password = "";
      self.MemberID = "";
      self.CardID = "";
      self.TenantID = "";
      self.Tenant = "";
      self.Email = "";
      self.RoleId = 0;
      self.Telephone = "";
      self.RedemptionType = null;
      self.UserLevel = null;
      self.ActiveStatus = null;
      self.Department = null;
      self.RedemptionStatus = false;
    },

    GetColor(value) {
      if (value == true) {
        return "rgb(92, 184, 92,0.3)";
      } else {
        return "rgb(232, 34, 34,0.3)";
      }
    },

    GetColorText(value) {
      if (value == true) {
        return "rgb(92, 184, 92)";
      } else {
        return "rgb(232, 34, 34)";
      }
    },
  },
};
</script>
<style scoped>
* >>> .v-data-table-header {
  background-color: black;
  color: #ffffff !important;
}
* >>> .v-data-table-header th {
  font-size: 14px !important;
  color: #ffffff !important;
}

@keyframes load {
  0% {
    transform: scaleY(0.4);
  }
  20% {
    transform: scaleY(1);
  }
  40% {
    transform: scaleY(0.4);
  }
  100% {
    transform: scaleY(0.4);
  }
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
.rect2 {
  animation-delay: -1.2s;
}
.rect3 {
  animation-delay: -1.1s;
}
.rect4 {
  animation-delay: -1s;
}
.rect5 {
  animation-delay: -0.9s;
}

.page-title {
  color: #444;
  font-size: 22px;
  margin-left: 1rem;
}

.cell {
  color: #333;
  font-size: 14px;
  padding: 10px 8px;
}

.data-table {
  color: #332f2f;
}

.v-data-table-header th {
  font-weight: 600 !important;
  font-size: 14px !important;
  background-color: #333 !important;
  color: white !important;
}

.rounded-lg {
  border-radius: 12px !important;
}

.rounded-xl {
  border-radius: 16px !important;
}

h1 {
  letter-spacing: 0.5px;
}

.v-text-field input {
  font-size: 15px;
}

.section-header {
  font-size: 16px;
  font-weight: 700;
  color: #1e1e1e;
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}

.rounded-xl {
  border-radius: 16px !important;
}

.v-text-field input,
.v-select input {
  font-size: 15px;
}
</style>
